var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"M95tqydpe8nYsUJwHXPLE"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/web";

// Copypasted/modified from https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/
import * as Sentry from '@sentry/nextjs';

import { sentryOptions } from './sentry.config';

Sentry.init(sentryOptions);
